// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"b5538a8f","800":"b5538a8f","980":"fb28c9a2"}[chunkId] + ".chunk.css";
};